export const SUPPORTED_LOCALES = ['en', 'ru'] as const;
export type Locale = typeof SUPPORTED_LOCALES[number];

export function normalizeLocale(value: unknown): Locale | null {
  if (typeof value !== 'string') return null;
  const language = value.trim().toLowerCase().split(/[-_]/, 1)[0];
  return SUPPORTED_LOCALES.find((locale) => locale === language) || null;
}

export function normalizeEnabledLocales(value: unknown): Locale[] {
  const source = Array.isArray(value) ? value : [];
  const result = source.map(normalizeLocale).filter((locale): locale is Locale => Boolean(locale));
  return [...new Set(result)];
}

export function parseEnabledLocales(value: unknown): Locale[] {
  if (Array.isArray(value)) return normalizeEnabledLocales(value);
  if (typeof value !== 'string') return [];
  try { return normalizeEnabledLocales(JSON.parse(value) as unknown); }
  catch { return []; }
}

export function resolveLocale(input: {
  preferredLocale?: unknown;
  telegramLanguageCode?: unknown;
  enabledLocales?: unknown;
  defaultLocale?: unknown;
}): Locale {
  const enabled = normalizeEnabledLocales(input.enabledLocales);
  const available = enabled.length ? enabled : [...SUPPORTED_LOCALES];
  const allowed = (candidate: Locale | null): candidate is Locale => Boolean(candidate && available.includes(candidate));
  const preferred = normalizeLocale(input.preferredLocale);
  if (allowed(preferred)) return preferred;
  const telegram = normalizeLocale(input.telegramLanguageCode);
  if (allowed(telegram)) return telegram;
  const fallback = normalizeLocale(input.defaultLocale);
  if (allowed(fallback)) return fallback;
  if (available.includes('en')) return 'en';
  return available[0] || 'en';
}
